import {Component, ElementRef, inject, Inject, OnInit, ViewChild} from '@angular/core';
import {Customer} from '../../Models/Customer/Customer';
import {MatTableDataSource} from '@angular/material/table';
import {GetAllCustomersCB} from '../../Ope/Customer/GetAllCustomersCB';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {PageEvent} from '@angular/material/paginator';
import {PutCustomerUserCB} from '../../Ope/CustomerUser/PutCustomerUserCB';
import {DelCustomerUserCB} from '../../Ope/CustomerUser/DelCustomerUserCB';
import {ChangeUserOwnerCB} from '../../Ope/CustomerUser/ChangeUserOwnerCB';
import {GetCustomerUsersCB} from '../../Ope/CustomerUser/GetCustomerUsersCB';
import {CustomerUser} from '../../Models/CustomerUser/CustomerUser';
import {CustomerUserDetailComponent} from './customerUserDetail/customerUserDetail.component';
import {ResetPasswordByEmailCB} from '../../Ope/CustomerUser/ResetPasswordByEmailCB';
import {GetUserTokenCB} from '../../Ope/CustomerUser/GetUserTokenCB';
import {CustomerService} from "../../Services/Ope/Customer.service";
import {CustomerUserService} from "../../Services/Ope/CustomerUser.service";
import {BaseComponent} from "../common/BaseComponent";
import {BaseDialogComponent} from "../common/BaseDialogComponent";
import {FormControl} from "@angular/forms";
import {map, Observable, startWith} from "rxjs";

@Component({
  selector: 'app-customer-user-registry',
  templateUrl: './customerUserRegistry.component.html',
  styleUrls: ['./customerUserRegistry.component.css', '../common/drawer-style.css']
})
export class CustomerUserRegistryComponent extends BaseComponent implements OnInit {

  @ViewChild(CustomerUserDetailComponent) customerUserDetail?: CustomerUserDetailComponent;

  // ***************************
  //   PAGINATION OPTIONS
  // ***************************
  readonly PAGESIZE_OPTIONS = [10, 20, 30];
  totalPages?: number;
  totalElements?: number;
  page = 0;
  pageSize = this.PAGESIZE_OPTIONS[0];

  customerSelectionControl = new FormControl('');
  allCustomers?: Customer[];
  filteredCustomers!: Observable<Customer[]>;
  selectedCustomer?: Customer;

  users?: CustomerUser[];
  newUser?: CustomerUser;
  expandedElement?: CustomerUser;

  displayedColumns: string[] = ['email', 'firstname', 'lastname', 'actions'];
  tableDataSource!: MatTableDataSource<CustomerUser>;

  editMode = false;
  formValidationOk = true;

  customerUsersLoading = false;
  searchEnabled = false;
  userNameToFind?: string;

  public customerService = inject(CustomerService);
  private customerUserService = inject(CustomerUserService);

  ngOnInit(): void {
    this.getAllCustomers();
  }

  private _filter(value: string): Customer[] {
    const filterValue = value.toLowerCase();
    return this.allCustomers!.filter(customer => customer.title.toLowerCase().includes(filterValue));
  }
  displayFn(customer: Customer): string {
    return customer? customer.title : '';
  }
  clearSelection() {
    this.customerSelectionControl.patchValue("");
    this.selectedCustomer = undefined;
    this.users = undefined;
  }
  getAllCustomers() {
    const cb = new GetAllCustomersCB();

    this.customerService.getAllCustomers(cb).subscribe(
      () => {
        this.allCustomers = cb.o.customers.sort((a, b) => a.title.localeCompare(b.title));
        this.filteredCustomers = this.customerSelectionControl.valueChanges.pipe(
          startWith(''),
          map( value => {
            if(!value){
              return  this.allCustomers!.slice();
            }
            const title = typeof value === 'string' ? value : (value as unknown as Customer).title;
            return title ? this._filter(title as string) : this.allCustomers!.slice()}),
        );
      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    );
  }

  getCustomerUsers() {
    this.customerUsersLoading = true;
    this.tableDataSource = new MatTableDataSource<CustomerUser>();
    if (!!this.selectedCustomer) {
      const cb = new GetCustomerUsersCB();
      cb.i.customerId = this.selectedCustomer.id;
      cb.i.pageSize = this.pageSize;
      cb.i.page = this.page;
      cb.i.textSearch = (!!this.userNameToFind && this.userNameToFind != '') ? this.userNameToFind : undefined;

      this.customerUserService.getCustomerUsers(cb).subscribe(
        () => {
          this.users = cb.o.users.sort((a, b) => a.email.localeCompare(b.email));
          this.totalElements = cb.o.totalElements;
          this.totalPages = cb.o.totalPages;
          this.tableDataSource = new MatTableDataSource<CustomerUser>(this.users);
          this.customerUsersLoading = false;

          // Update the Expanded element
          if (!!this.expandedElement) {
            this.expandedElement = this.users.find(a => a.id === this.expandedElement?.id);
          }

          this.editMode = false;
        }, error => {
          this.gmService.openErrorSnackbar(error);
          this.tableDataSource = new MatTableDataSource<CustomerUser>();
          this.customerUsersLoading = false;
        }
      );

    }

  }

  /**
   * listen to Paginator event
   */
  public getPaginatorData(event: PageEvent): PageEvent {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getCustomerUsers();
    return event;
  }

  addNewUser() {
    this.newUser = new CustomerUser();

    const dialogRef = this.dialog.open(PutCustomerUserDialogComponent, {
      width: '600px',
      data: {
        user: this.newUser,
        customer: this.selectedCustomer
      }
    });

    dialogRef.afterClosed().subscribe(
      (password) => {
        if (!!password) {
          this.gmService.openInfoSnackbar(`${this.translate.instant('USER.ADD_OK')} ${password}`);
          this.getCustomerUsers();
        }
      }, error => {
        console.log(error);
      }
    );
  }


  updateUser() {

    const user = this.customerUserDetail?.dataDetail;

    if (!!user && !!this.selectedCustomer) {
      const cb = new PutCustomerUserCB();

      cb.i.id = user.id;
      cb.i.firstname = user.firstname;
      cb.i.lastname = user.lastname;
      cb.i.email = user.email;
      cb.i.customerId = this.selectedCustomer.id;

      this.customerUserService.putCustomerUser(cb).subscribe(
        () => {
          this.gmService.openSuccessSnackbar(this.translate.instant('USER.UPDATE_OK'));
          this.getCustomerUsers();
        }, error => {
          this.gmService.openErrorSnackbar(error);
        }
      )
    }


  }

  deleteUser(row: CustomerUser) {
    const dialogRef = this.dialog.open(AreUSureDeleteUserDialogComponent, {
      width: '500px',
      data: `${row.firstname} ${row.lastname}`
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {

          const cb = new DelCustomerUserCB();
          cb.i.id = row.id;

          this.customerUserService.delCustomerUser(cb).subscribe(
            () => {
              this.gmService.openSuccessSnackbar(this.translate.instant('USER.DELETE_OK'));
              this.getCustomerUsers();
            }, error => {
              this.gmService.openErrorSnackbar(error);
            }
          );


        }
      }, error => {
        console.log(error);
      }
    );
  }

  changeUserOwner(element: CustomerUser) {
    this.newUser = JSON.parse(JSON.stringify(element));

    const dialogRef = this.dialog.open(ChangeCustomerUserOwnerDialogComponent, {
      width: '600px',
      data: {
        user: this.newUser,
        selectedCustomer: this.selectedCustomer,
        allCustomers: this.allCustomers
      }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (!!res) {
          this.gmService.openSuccessSnackbar(this.translate.instant('USER.CHANGE_OWNER_OK'));
          this.getCustomerUsers();
        }
      }, error => {
        console.log(error);
      }
    );
  }

  resetPassword(element: CustomerUser) {
    const cb = new ResetPasswordByEmailCB();
    cb.i.userId = element.id;

    this.customerUserService.resetPasswordByEmail(cb).subscribe(
      () => {
        this.gmService.openSuccessSnackbar(this.translate.instant('USER.RESET_PASSWORD_BY_EMAIL'));
      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    );

  }

  showDetail(element: any): void {
    this.editMode = false;
    this.expandedElement = this.expandedElement === element ? undefined : element;
  }

  hideElement() {
    this.expandedElement = undefined;
  }

  manageFormValidation($event: boolean) {
    this.formValidationOk = $event;
  }

  enterAsUser(element: CustomerUser) {

    const cb = new GetUserTokenCB();
    cb.i.userId = element.id;
    this.customerUserService.getUserToken(cb).subscribe(
      () => {

        this.gmService.redirectToThingsBoard(cb.o.access_token);

      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    );


  }
}


/*--------------------------------
    CHANGE USER OWNER COMPONENT
 -------------------------------*/

@Component({
  templateUrl: 'change-user-owner-dialog.html',
  selector: 'app-change-user-owner-dialog',
  styleUrls: ['../common/dialog-style.css']
})
export class ChangeCustomerUserOwnerDialogComponent extends BaseDialogComponent<ChangeCustomerUserOwnerDialogComponent> {

  parentId?: string;
  parentCustomer?: Customer;
  filteredCustomers?: Observable<any>;
  customerSelectionControl = new FormControl('');
  private customerUserService = inject(CustomerUserService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();

    this.parentId = data.selectedCustomer?.id;
    this.filterCustomer_init()
  }

  //------
  // Filterable customer List
  //------
  filterCustomer_init(){
    this.filteredCustomers = this.customerSelectionControl.valueChanges.pipe(
      startWith(''),
      map( value => {
        const title = typeof value === 'string' ? value : (value as unknown as Customer).title;
        return title ? this._filter(title as string) : this.data.allCustomers!.slice()}),
    );
  }

  private _filter(value: string): Customer[] {
    const filterValue = value.toLowerCase();
    return this.data.allCustomers!.filter((x: Customer)=> x.title.toLowerCase().includes(filterValue));
  }
  displayFn(customer: Customer): string {
    return customer? customer.title : '';
  }

  checkSelection(): void {
    if(typeof this.customerSelectionControl.value != 'object') {
      this.parentId = this.data.selectedCustomer?.id;
      this.filterCustomer_init();
      this.customerSelectionControl.patchValue('');
    }
  }

  //------
  changeUserOwner() {

    if (this.parentId) {
      const cb = new ChangeUserOwnerCB();
      cb.i.id = this.data.user.id;
      cb.i.newOwnerId = this.parentId;

      this.customerUserService.changeUserOwner(cb).subscribe(
        () => {
          this.closeDialog(true);
        }, error => {
          this.gmService.openErrorSnackbar(error);
        }
      );
    }

  }

  protected readonly Customer = Customer;
}


/*--------------------------------
    PUT CUSTOMER USER COMPONENT
 -------------------------------*/

@Component({
  templateUrl: 'put-customer-user-dialog.html',
  selector: 'app-put-customer-user-dialog',
  styleUrls: ['../common/dialog-style.css']
})
export class PutCustomerUserDialogComponent extends BaseDialogComponent<PutCustomerUserDialogComponent> {

  private customerUserService = inject(CustomerUserService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();
  }

  saveCustomerUser() {

    const cb = new PutCustomerUserCB();

    cb.i.id = this.data.user.id;
    cb.i.firstname = this.data.user.firstname;
    cb.i.lastname = this.data.user.lastname;
    cb.i.email = this.data.user.email;
    cb.i.customerId = this.data.customer.id;

    this.customerUserService.putCustomerUser(cb).subscribe(
      () => {
        // Se è un'aggiunta, devo restituire la password da mostrare, altrimenti semplicemente rispondo che è andato tutto bene
        this.closeDialog((!!cb.o.password) ? cb.o.password : true);
      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    )
  }

}

/*--------------------------------
     DELETE CUSTOMER COMPONENT
 -------------------------------*/

@Component({
  templateUrl: '../common/are-u-sure-delete-dialog.html',
  selector: 'app-are-u-sure-delete-dialog',
  styleUrls: ['../common/dialog-style.css']
})
export class AreUSureDeleteUserDialogComponent extends BaseDialogComponent<AreUSureDeleteUserDialogComponent> {

  entity = "Utente";


  constructor(@Inject(MAT_DIALOG_DATA) public customerTitle: string) {
    super();
  }

}
